(function ($) {
	const app = {
		windowHeight: $(window).height(),
		windowWidth: $(window).width(),
		isMobile: false,
		isTouch: false,
		resizeTimeoutID: null,
		$body: $('body'),
		culture: 'en',
		isIe: false,
		isTabletPortrait: false,
		responsiveBreakpointValue: '(max-width: 1200px)',
		responsiveBreakpointBoolean: false,
		hamburgerBoolean: false,
		hamburgerBoolean2: false,
		successSwiper: false,
		//	gallerySlider: '',
		detectDevice() {

			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
					app.isMobile = true;
				}
			}(navigator.userAgent || navigator.vendor || window.opera));
			if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
				app.isTouch = true;
				app.$body.addClass('touch');
			} else {
				app.$body.addClass('no-touch');
			}
			if (app.windowWidth <= 992) {
				app.isTabletPortrait = true
				app.disableSpotlightScroll = true
			}
		},
		detectCulture() {
			if ($('html').attr('lang') === 'ar') {
				app.culture = 'ar';
			}
		},
		windowResize() {
			app.windowHeight = $(window).height();
			app.windowWidth = $(window).width();
			$('.spotlight__slide.swiper-slide').height($('.swiper-spacer').outerHeight())
		},
		resizeListner() {
			if (!app.isMobile) {
				$(window).resize(() => {
					clearTimeout(app.resizeTimeoutID);
					app.resizeTimeoutID = setTimeout(app.windowResize, 500);
				});
			} else {
				window.addEventListener('orientationchange', () => {
					app.windowResize();
				});
			}
		},

		_getCookie: function (cookieName) {
			var cookieNameEQ = cookieName + "=";
			var ca = document.cookie.split(";");
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == " ") c = c.substring(1, c.length);
				if (c.indexOf(cookieNameEQ) == 0)
					return c.substring(cookieNameEQ.length, c.length);
			}
			return null;

		},
		addEventListner() {
			$('.success ul li').click(function () {
				$('.success ul li').removeClass('active')
				$(this).addClass('active');
				$('.success-row').hide();

				//	$('row.international,row.startup').hide()
				$('.' + $(this).attr('data-name')).show();

				console.log(app.successSwiper)
				console.log(app.successSwiper[0].update())
				console.log(app.successSwiper[1].update())



			})

			$('.agenda-slot--mob').click(function () {

				if (app.windowWidth <= 992) {
					$(this).find('.agenda-slot__body').slideToggle()
					$(this).toggleClass('active')
				}
			})


			$('.agenda-days').eq(0).show();

			$(' .workshops-cont .swiper-button-prev').click(function () {
				$('.agenda-days').hide();


				if ($(this).hasClass('swiper-button-first')) {
					$('.agenda-days').eq(2).show()
				}
				else {
					$(this).parents('.agenda-days').prev('.agenda-days').show()
				}


			})
			$(' .workshops-cont .swiper-button-next').click(function () {
				$('.agenda-days').hide();


				if ($(this).hasClass('swiper-button-last')) {
					$('.agenda-days').eq(0).show()
				}
				else {
					$(this).parents('.agenda-days').next('.agenda-days').show()
				}


			})


			$('.agenda-cont .swiper-button-next, .agenda-cont  .swiper-button-prev').click(function () {
				$('.agenda-days').show();
				$(this).parents('.agenda-days').hide()
			})

			// $('.register-btn').click(function (e) {
			// 	e.preventDefault();
			// 	$('form.row,.register-details').hide();
			// 	$('.enquiry-form__msg').show()
			// })

			// Termds and Condation Overlay
			$('.terms-of-use__close').on('click', function () {
				$(this).parents(".terms-of-use").fadeOut();
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "terms of use",
					"event_lab": "close"
				});

			});

		},

		lazyLoad: function () {

			var lazyLoadInstance = new LazyLoad({
				// Your custom settings go here
			});
		},

		mobileSwiper: function () {

			if (app.isTabletPortrait) {


				$('.mobile-swiper').addClass('swiper')
				$('.mobile-swiper-wrapper').addClass('swiper-wrapper').removeClass('row')
				$('.mobile-swiper-slide').addClass('swiper-slide').removeClass('col-12').removeClass('col-lg-5').removeClass('offset-lg-1')

				new Swiper('.latest-updates .mobile-swiper', {
					// Optional parameters
					slidesPerView: 1,
					spaceBetween: 0,
					autoHeight: false,
					pagination: {
						el: '.latest-updates .mobile-swiper .swiper-pagination',
						type: 'bullets',
						clickable: true
					},
					breakpoints: {


						768: {
							slidesPerView: 1.6,
							spaceBetween: 20
						}
					},
					navigation: {
						nextEl: '.latest-updates .mobile-swiper .swiper-button-next',
						prevEl: '.latest-updates .mobile-swiper .swiper-button-prev',
					},
				});


				//  Stay Informed Slider

				$('.stay-informed__grid,.offers-on-us__grid').addClass('swiper-wrapper')
				$('.stay-informed__grid-wrap,.offers-on-us__grid-wrap').addClass('swiper')
				$('.stay-informed__item,.offers-on-us__item').addClass('swiper-slide')

				new Swiper('.stay-informed__grid-wrap.swiper,.offers-on-us__grid-wrap.swiper', {
					// Optional parameters
					slidesPerView: 1.2,
					spaceBetween: 20,
					autoHeight: false,

					breakpoints: {


						768: {
							slidesPerView: 2.5,
							spaceBetween: 20
						}
					},
					// pagination: {
					// 	el: '.latest-updates .mobile-swiper .swiper-pagination',
					// 	type: 'bullets',
					// 	clickable: true
					// },
					// navigation: {
					// 	nextEl: '.latest-updates .mobile-swiper .swiper-button-next',
					// 	prevEl: '.latest-updates .mobile-swiper .swiper-button-prev',
					// },
				});

			}

		},
		swiper: function () {

			const myCustomSlider = document.querySelectorAll(".generic-slider--fans .swiper");
			const myCustomSliderPagination = document.querySelectorAll(".generic-slider--fans  .swiper-pagination");

			for (let i = 0; i < myCustomSlider.length; i++) {
				myCustomSlider[i].classList.add("carousel-" + i);
				myCustomSliderPagination[i].classList.add("pg-" + i);

				new Swiper(".carousel-" + i, {
					// Optional parameters
					loop: true,
					slidesPerView: 1.2,
					spaceBetween: 20,
					autoHeight: false,
					pagination: {
						el: ".pg-" + i,
						type: 'bullets',
						clickable: true
					},
					navigation: {
						nextEl: '.generic-slider--fans  .swiper-button-next',
						prevEl: '.generic-slider--fans  .swiper-button-prev',
					},

					breakpoints: {
						// when window width is >= 320px
						500: {
							slidesPerView: 'auto',
						},

					}
				});
			}




			// new Swiper(".carousel-" + i, {
			// 	// Optional parameters

			// 	slidesPerView: 1.2,
			// 	spaceBetween: 20,
			// 	autoHeight: false,
			// 	pagination: {
			// 		eel: ".pg-" + i,
			// 		type: 'bullets',
			// 		clickable: true
			// 	},
			// 	navigation: {
			// 		nextEl: '.generic-slider--fans  .swiper-button-next',
			// 		prevEl: '.generic-slider--fans  .swiper-button-prev',
			// 	},

			// 	breakpoints: {
			// 		// when window width is >= 320px
			// 		500: {
			// 			slidesPerView: 'auto',
			// 		},

			// 	}
			// });
			new Swiper('.generic-slider--explore .swiper', {
				// Optional parameters

				slidesPerView: 1.2,
				spaceBetween: 20,
				autoHeight: false,
				pagination: {
					el: '.generic-slider--explore  .swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: '.generic-slider--explore  .swiper-button-next',
					prevEl: '.generic-slider--explore  .swiper-button-prev',
				},

				breakpoints: {
					// when window width is >= 320px
					992: {
						slidesPerView: 2,
					},

				}

			});
			new Swiper('.about-features .swiper', {
				// Optional parameters
				slidesPerView: "auto",
				spaceBetween: 20,

			});
			new Swiper('.fortnite-slider .swiper', {
				// Optional parameters
				slidesPerView: "auto",
				spaceBetween: 20,
				autoHeight: true,
				pagination: {
					el: '.fortnite-slider  .swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: '.fortnite-slider  .swiper-button-next',
					prevEl: '.fortnite-slider  .swiper-button-prev',
				},
			});
			new Swiper('.swiper.event-partners', {
				// Optional parameters
				slidesPerView: 1,
				slidesPerView: "auto",
				spaceBetween: 100,
				pagination: {
					el: '.event-partners .swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				breakpoints: {
					992: {
						slidesPerView: 3,
					},

				}
			});
			new Swiper('.generic-slider--explore .swiper', {
				// Optional parameters

				slidesPerView: 1.2,
				spaceBetween: 20,
				autoHeight: false,
				pagination: {
					el: '.generic-slider--explore  .swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: '.generic-slider--explore  .swiper-button-next',
					prevEl: '.generic-slider--explore  .swiper-button-prev',
				},

				breakpoints: {
					// when window width is >= 320px
					992: {
						slidesPerView: 2,
					},

				}

			});

			let mqlminwidth = window.matchMedia('(min-width: 768px)');
			let mqlmaxwidth = window.matchMedia('(max-width: 768px)');

			if (mqlmaxwidth.matches) {
				$('.tickets.ticket-page').addClass('swiper');
				$('.tickets.ticket-page .tickets__grid').addClass('swiper-wrapper');
				$('.tickets.ticket-page .tickets__grid .tickets__grid-item').addClass('swiper-slide');


				new Swiper('.tickets', {
					// Optional parameters
					slidesPerView: 1.1,
					spaceBetween: 16,
					autoHeight: false,
					pagination: {
						el: '.tickets__grid-pagination',
						type: 'bullets',
						clickable: true
					},
					breakpoints: {
						// when window width is >= 320px
						992: {
							spaceBetween: 30,
							slidesPerView: 3,
						},

					}

				});
			}
			if (mqlminwidth.matches) {

				new Swiper('.generic-slider--callout .swiper', {
					// Optional parameters

					slidesPerView: 1,
					spaceBetween: 0,
					autoHeight: false,
					pagination: {
						el: '.generic-slider--callout .swiper-pagination',
						type: 'bullets',
						clickable: true
					},
					navigation: {
						nextEl: '.generic-slider--callout .swiper-button-next',
						prevEl: '.generic-slider--callout .swiper-button-prev',
					},

					breakpoints: {
						// when window width is >= 320px
						992: {
							spaceBetween: 30,
							slidesPerView: 3,
						},

					}

				});


			}

			new Swiper('.tickets.home.swiper', {
				// loop: true,
				slidesPerView: 1.05,
				spaceBetween: 0,
				autoHeight: false,
				pagination: {
					el: '.tickets__grid-pagination.home',
					type: 'bullets',
					clickable: true
				},
				breakpoints: {
					// when window width is >= 320px
					1366: {
						spaceBetween: 0,
						slidesPerView: 2.5,
					},

					1400: {
						spaceBetween: 0,
						slidesPerView: 3,
					},
					1920: {
						spaceBetween: 0,
						slidesPerView: 3.5,
					},


				}
			})

			new Swiper('.dominose-pro.swiper', {
				// Optional parameters

				slidesPerView: 2,
				spaceBetween: 20,
				autoHeight: false,
				// pagination: {
				// 	el: '.generic-slider--explore  .swiper-pagination',
				// 	type: 'bullets',
				// 	clickable: true
				// },
				navigation: {
					nextEl: '.dominose-pro .c-nav-next',
					prevEl: '.dominose-pro .c-nav-prev',
				},

				breakpoints: {
					// when window width is >= 320px


					992: {
						slidesPerView: 3,

					},
					1400: {
						slidesPerView: 4,
					},

				}

			});





		},

		mobileNav() {

			$('.header-mobile__icon').on('click', function () {
				$('.m-nav-overlay').show();
				app.$body.addClass('scroll-none');
			});

			$('.m-nav-overlay__icon').on('click', function () {
				$('.m-nav-overlay').hide();
				app.$body.removeClass('scroll-none');
			});

			$('.nav-m__link').on('click', function () {
				$(this).next().slideToggle();
			})

		},
		tabs() {
			$(".tabs-menu .tabs-menu__link a").click(function (event) {
				const navText = $(this).text().toLowerCase();
				// alert(navText)
				event.preventDefault();
				$(this).parent().siblings().removeClass("active");
				$(this).parent().addClass("active");
				var tab = $(this).attr("href");
				$(this).parents('.tabs-menu').next().find(".tab-pane").not(tab).css("display", "none");
				$(tab).addClass("show").fadeIn();
				$(tab).siblings().removeClass("show");
				//debugger
				if (typeof (utag) !== 'undefined') {

					utag.link({
						"event_name": "eventTracker",
						"event_cat": "modules",
						"event_act": "getting to gameexpo",
						"event_lab": navText
					});
				}
			});
			let url = window.location;
			let qs = url.hash;
			let qsText = qs.slice(1, qs.length);


			if (qsText) {
				$('[href="#' + qsText + '"]').click();
			}

		},
		spotlightForm() {
			$(".ticket-def").on('click', function () {
				//$(this).fadeOut();
				///$(".ticket-def-form").fadeIn();
				//$(this).parents('.spotlight').addClass('spotlight--height-fix')
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "tickets for def2022 go on sale soon",
					"event_lab": "enter email"
				});
			});
		},
		privacyDrawer() {
			$('.privacy-overlay__close,#acceptAll,#rejectAll').on('click', function () {
				$('.privacy-overlay').addClass('close');
				app._createCookie("popupCookies", true, 360);
			});

			if (app._getCookie('popupCookies') === 'true') {
				$('.privacy-overlay').addClass('close');
			} else {
				$(".privacy-overlay").removeClass('close');
			}

		},

		_createCookie: function (cookieName, cookieValue, cookieDays) {
			var expires = "";
			if (cookieDays) {
				var date = new Date();
				date.setTime(date.getTime() + cookieDays * 24 * 60 * 60 * 1000);
				expires = "; expires=" + date.toDateString();
			}
			document.cookie = cookieName + " = " + cookieValue + ";" + expires + "; path=/en/;secure;samesite=strict";
		},

		_deleteCookies: function (cookieName) {
			var expires = "; expires=Thu, 01 Jan 1970 00:00:01 GMT";
			// document.cookie = '{cookieName} = ${expires} path=/';
			//document.cookie = cookieName + " = " + expires + " path=/";

			document.cookie = cookieName + '=; Max-Age=-99999999;';
		},

		_getCookie: function (cookieName) {
			var cookieNameEQ = cookieName + "=";
			var ca = document.cookie.split(";");
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == " ") c = c.substring(1, c.length);
				if (c.indexOf(cookieNameEQ) == 0)
					return c.substring(cookieNameEQ.length, c.length);
			}
			return null;

		},

		formValidation: function () {
			var isFormValid = false
			var isSearch = false
			const overlayBgSelector = $('.overlay-bg');

			const alphaError = $('body').hasClass('ar') ? "الأرقام غير مسموح بها" : "Numbers are not allowed";

			function _capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1);
			}


			function _formValidationNSubmission(selector, submitFunc) {

				// console.log($(selector));

				$(selector).validate({

					// Make sure the form is submitted to the destination defined
					// in the "action" attribute of the form when valid
					rules: {

						firstname: {
							required: true,
							alpha: true

						},


						lastname: {
							required: true,
							alpha: true
						},

						email: {
							customEmail: true,
							required: true,
							maxlength: 64
						},

						message: {
							required: true,
						},
						digitalearning: {
							required: true,
						},

						designation: {
							required: true,
						},

						companyname: {
							required: true,
						},

						sponsorship: {
							required: true,
						},

						jobtitle: {
							required: true,
						},

						toattendsummit: {
							required: true,
						},

						initiateSummit: {
							required: true,
						},

						gamerhandle: {
							required: true,
						},
						gamertagorgamerhandle: {
							required: true,
						},

						areaofinterest: {
							required: true,
						},

						Sponsors: {
							required: true,
						},

						fanExpo: {
							required: true,
						},

						generalEnquiries: {
							required: true,
						},

						agree: {
							required: true,
						},

						gender: {
							required: false,
						},
						yeargroup: {
							required: true,
						},
						teamname: {
							required: true,
						},
						schoolname: {
							required: true,
						},
						schoollocation: {
							required: true,
						}

					},
					messages: {

						firstname: {
							alpha: alphaError,
						},
						message: $('body').hasClass('ar') ? "Pleae add you message" : "Pleae add you message",

					},
					highlight: function (element) {
						$(element).parent().addClass("field-error");

						$(element).parents('fieldset').find('legend').addClass("field-error");
					},
					unhighlight: function (element) {
						$(element).parent().removeClass("field-error");
						$(element).parents('fieldset').find('legend').removeClass("field-error");
					},
					submitHandler: function (form) {

						// form.submit();
						// alert('form is valid')
						isFormValid = true;
						app.$body.addClass('loading');
						// _formSubmit(form);
						submitFunc(selector);

						if (selector === '.eloqua-form-spotlight') {
							// console.log(selector + ' submit');
							utag.link({
								"event_name": "eventTracker",
								"event_cat": "modules",
								"event_act": "tickets for def2022 go on sale soon",
								"event_lab": "submit"
							});
						}

						if (selector === '.eloqua-form-home') {
							console.log(selector + ' Sign Up success');
							utag.link({
								"event_name": "eventTracker",
								"event_cat": "modules",
								"event_act": "updated and giveways? we’ve got them",
								"event_lab": "sign up success"
							});
						}

						// _defExperienceTabUTagGenericSuccess();

					}
				});

			};



			function _defExperienceTabUTagGenericSubmit() {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "join the def experience",
					"event_lab": "submit"
				});
			}

			function _defExperienceTabUTagGenericSuccess() {

				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "join the def experience",
					"event_lab": "submit success"
				});

			}

			function _defExperienceTabUTagGenericFailure() {
				if ($('.def-experiecne form').length) {
					console.log(' Tabs all Sign Up Fail');
					//debugger
					utag.link({
						"event_name": "eventTracker",
						"event_cat": "modules",
						"event_act": "join the def experience",
						"event_lab": "submit failure"
					});

				}
			}

			function _formSubmitFormHome(selector) {
				const currentForm = $(selector);

				var form = new FormData();
				form.append("elqFormName", "DEFTicketRegistration");
				form.append("elqSiteID", "1625795586");
				form.append("emailAddress", currentForm.find('input[name=email]').val());
				form.append("firstName", _capitalizeFirstLetter(currentForm.find('input[name=firstname]').val()));
				form.append("lastName", _capitalizeFirstLetter(currentForm.find('input[name=lastname]').val()));

				if (currentForm.find('#phone-1').length) {
					form.append("phoneNumber", $('#phone-1').val().length < 5 ? '' : $('#phone-1').val());
				} else {
					form.append("phoneNumber", $('#phone-6').val().length < 5 ? '' : $('#phone-6').val());
				}

				form.append("language", app.culture);
				form.append("country", currentForm.find('select[name=countries]').val());
				form.append("googleClientID", app._getCookie('_ga'));
				form.append("gender", currentForm.find('select[name=gender]').val() !== undefined ? currentForm.find('select[name=gender]').val() : '');
				form.append("isSubscribed", "true");



				console.log(`
				
				
				emailAddress", ${currentForm.find('input[name=email]').val()}
				firstName", ${_capitalizeFirstLetter(currentForm.find('input[name=firstname]').val())}
				lastName", ${_capitalizeFirstLetter(currentForm.find('input[name=lastname]').val())}
				phoneNumber", ${$('#phone-6').val().length < 5 ? '' : $('#phone-6').val()}
				language", ${app.culture}
				country", ${currentForm.find('select[name=countries]').val()}
				googleClientID", ${app._getCookie('_ga')}
				gender", ${currentForm.find('select[name=gender]').val()}


				`);

				var settings = {
					"url": "https://tracking.visitdubai.com/e/f2",
					"method": "POST",
					"timeout": 0,
					"processData": false,
					"mimeType": "multipart/form-data",
					"contentType": false,
					"data": form
				};

				console.log(form);

				$.ajax(settings)
					.done(function (response) {
						console.log(response);
						app.$body.removeClass('loading');
						overlayBgSelector.css('display', 'flex');
						/* utag.link({
							"event_name": "eventTracker",
							"event_cat": "modules",
							"event_act": "Tickets For def2022 Go on Sale Soon 3",
							"event_lab": "Submit"
						}); */
					})
					.fail(function () {

						if (selector === '.eloqua-form-home') {
							console.log(selector + ' Sign Up failure');
							utag.link({
								"event_name": "eventTracker",
								"event_cat": "modules",
								"event_act": "updated and giveways? we’ve got them",
								"event_lab": "sign up failure"
							});
						}

					});



			}

			function _formSubmitForm1(selector) {
				const currentForm = $(selector);

				var form = new FormData();
				form.append("elqFormName", "DEFGeneralEnquiryForm");
				form.append("elqSiteID", "1625795586");
				form.append("emailAddress", currentForm.find('input[name=email]').val());
				form.append("firstName", _capitalizeFirstLetter(currentForm.find('input[name=firstname]').val()));
				form.append("lastName", _capitalizeFirstLetter(currentForm.find('input[name=lastname]').val()));
				form.append("phoneNumber", $('#phone-2').val().length < 5 ? '' : $('#phone-2').val());
				form.append("language", app.culture);
				form.append("country", currentForm.find('select[name=countries]').val());
				form.append("message", currentForm.find('textarea[name=message]').val());
				form.append("googleClientID", app._getCookie('_ga'));
				form.append("isSubscribed", "true");


				console.log(`
				
				
				emailAddress", ${currentForm.find('input[name=email]').val()}
				firstName", ${_capitalizeFirstLetter(currentForm.find('input[name=firstname]').val())}
				lastName", ${_capitalizeFirstLetter(currentForm.find('input[name=lastname]').val())}
				phoneNumber", ${$('#phone-2').val().length < 5 ? '' : $('#phone-2').val()}
				language", ${app.culture}
				country", ${currentForm.find('select[name=countries]').val()}
				message", ${currentForm.find('textarea[name=message]').val()}


				`);

				var settings = {
					"url": "https://tracking.visitdubai.com/e/f2",
					"method": "POST",
					"timeout": 0,
					"headers": {
						"Cookie": "ELOQUA=GUID=F78C0284521B4A4C8C05406B3E064651; ELQSTATUS=OK"
					},
					"processData": false,
					"mimeType": "multipart/form-data",
					"contentType": false,
					"data": form
				};

				console.log(form);

				$.ajax(settings)
					.done(function (response) {
						console.log(response);
						app.$body.removeClass('loading');
						overlayBgSelector.css('display', 'flex');
						_defExperienceTabUTagGenericSuccess();
					})
					.fail(function () {
						_defExperienceTabUTagGenericFailure();
					});

			}

			function _formSubmitForm2(selector) {
				const currentForm = $(selector);

				var form = new FormData();
				form.append("elqFormName", "DEFSponsorsForm");
				form.append("elqSiteID", "1625795586");
				form.append("emailAddress", currentForm.find('input[name=email]').val());
				form.append("firstName", _capitalizeFirstLetter(currentForm.find('input[name=firstname]').val()));
				form.append("lastName", _capitalizeFirstLetter(currentForm.find('input[name=lastname]').val()));
				form.append("company", currentForm.find('input[name=companyname]').val());
				form.append("phoneNumber", $('#phone-3').val().length < 5 ? '' : $('#phone-3').val());
				form.append("country", currentForm.find('select[name=countries]').val());
				form.append("sponsorshipInterest", currentForm.find('select[name=sponsorship]').val());
				form.append("language", app.culture);
				form.append("googleClientID", app._getCookie('_ga'));
				form.append("isSubscribed", "true");
				form.append("designation", currentForm.find('input[name=designation]').val());

				console.log(`
				
				
				emailAddress", ${currentForm.find('input[name=email]').val()}
				firstName", ${_capitalizeFirstLetter(currentForm.find('input[name=firstname]').val())}
				lastName", ${_capitalizeFirstLetter(currentForm.find('input[name=lastname]').val())}
				company", ${currentForm.find('input[name=companyname]').val()}
				phoneNumber", ${$('#phone-3').val().length < 5 ? '' : $('#phone-3').val()}
				country", ${currentForm.find('select[name=countries]').val()}
				sponsorshipInterest", ${currentForm.find('select[name=sponsorship]').val()}
				designation", ${currentForm.find('input[name=designation]').val()}


				`);

				var settings = {
					"url": "https://tracking.visitdubai.com/e/f2",
					"method": "POST",
					"timeout": 0,
					"headers": {
						"Cookie": "ELOQUA=GUID=F78C0284521B4A4C8C05406B3E064651; ELQSTATUS=OK"
					},
					"processData": false,
					"mimeType": "multipart/form-data",
					"contentType": false,
					"data": form
				};

				console.log(form);


				$.ajax(settings)
					.done(function (response) {
						console.log(response);
						app.$body.removeClass('loading');
						overlayBgSelector.css('display', 'flex');
						_defExperienceTabUTagGenericSuccess();
					})
					.fail(function () {
						_defExperienceTabUTagGenericFailure();
					});

			}

			function _formSubmitForm3(selector) {
				const currentForm = $(selector);

				var form = new FormData();
				form.append("elqFormName", "DEFInitiateSummitForm");
				form.append("elqSiteID", "1625795586");
				form.append("emailAddress", currentForm.find('input[name=email]').val());
				form.append("firstName", _capitalizeFirstLetter(currentForm.find('input[name=firstname]').val()));
				form.append("lastName", _capitalizeFirstLetter(currentForm.find('input[name=lastname]').val()));
				form.append("phoneNumber", $('#phone-4').val().length < 5 ? '' : $('#phone-4').val());
				form.append("country", currentForm.find('select[name=countries]').val());
				form.append("jobTitle", currentForm.find('input[name=jobtitle]').val());
				form.append("company", currentForm.find('input[name=companyname]').val());
				form.append("reason", currentForm.find('input[name=toattendsummit]:checked').val());
				form.append("language", app.culture);
				form.append("googleClientID", app._getCookie('_ga'));
				form.append("isSubscribed", "true");

				console.log(`
				

				emailAddress", ${currentForm.find('input[name=email]').val()}
				firstName", ${_capitalizeFirstLetter(currentForm.find('input[name=firstname]').val())}
				lastName", ${_capitalizeFirstLetter(currentForm.find('input[name=lastname]').val())}
				phoneNumber", ${$('#phone-4').val().length < 5 ? '' : $('#phone-4').val()}
				country", ${currentForm.find('select[name=countries]').val()}
				jobTitle", ${currentForm.find('input[name=jobtitle]').val()}
				reason", ${currentForm.find('input[name=toattendsummit]:checked').val()}


				`);

				var settings = {
					"url": "https://tracking.visitdubai.com/e/f2",
					"method": "POST",
					"timeout": 0,
					"headers": {
						"Cookie": "ELOQUA=GUID=F78C0284521B4A4C8C05406B3E064651; ELQSTATUS=OK"
					},
					"processData": false,
					"mimeType": "multipart/form-data",
					"contentType": false,
					"data": form
				};

				$.ajax(settings)
					.done(function (response) {
						console.log(response);
						app.$body.removeClass('loading');
						overlayBgSelector.css('display', 'flex');
						_defExperienceTabUTagGenericSuccess();
					})
					.fail(function () {
						_defExperienceTabUTagGenericFailure();
					});

			}

			function _formSubmitForm4(selector) {


				const currentForm = $(selector);

				let areaOnInterestArr = [];

				currentForm.find('input[name=areaofinterest]:checked').each(function (i, elem) {
					areaOnInterestArr[i] = $(elem).val();
				});

				const interestedStringValue = areaOnInterestArr.join(', ');

				var form = new FormData();
				form.append("elqFormName", "DEFFanexpoForm");
				form.append("elqSiteID", "1625795586");

				form.append("emailAddress", currentForm.find('input[name=email]').val());
				form.append("firstName", _capitalizeFirstLetter(currentForm.find('input[name=firstname]').val()));
				form.append("lastName", _capitalizeFirstLetter(currentForm.find('input[name=lastname]').val()));
				form.append("phoneNumber", $('#phone-5').val().length < 5 ? '' : $('#phone-5').val());
				form.append("country", currentForm.find('select[name=countries]').val());
				form.append("language", app.culture);
				form.append("gamerHandle", currentForm.find('input[name=gamertagorgamerhandle]').val());
				form.append("areaOfInterest", interestedStringValue);
				form.append("googleClientID", app._getCookie('_ga'));
				form.append("isSubscribed", "true");

				form.append("isSubscribedPartners", currentForm.find('input[name=partnerSubscribe]').val());
				form.append("termsAndConditionSubscribed", currentForm.find('input[name=fanExpoPromotion]').val());


				console.log(`
				

				elqFormName, "DEFFanexpoForm;
				elqSiteID, "1625795586;
				emailAddress, ${currentForm.find('input[name=email]').val()};
				firstName, ${_capitalizeFirstLetter(currentForm.find('input[name=firstname]').val())};
				lastName, ${_capitalizeFirstLetter(currentForm.find('input[name=lastname]').val())};
				phoneNumber, ${$('#phone-5').val().length < 5 ? '' : $('#phone-5').val()};
				country, ${currentForm.find('select[name=countries]').val()};
				language, ${app.culture};
				gamerHandle, ${currentForm.find('input[name=gamertagorgamerhandle]').val()};
				areaOfInterest, ${interestedStringValue};
				googleClientID, ${app._getCookie('_ga')};
				isSubscribed, "true";


				`);


				var settings = {
					"url": "https://tracking.visitdubai.com/e/f2",
					"method": "POST",
					"timeout": 0,
					"headers": {
						"Cookie": "ELOQUA=GUID=F78C0284521B4A4C8C05406B3E064651; ELQSTATUS=OK"
					},
					"processData": false,
					"mimeType": "multipart/form-data",
					"contentType": false,
					"data": form
				};

				var settings = {
					"url": "https://tracking.visitdubai.com/e/f2",
					"method": "POST",
					"timeout": 0,
					"headers": {
						"Cookie": "ELOQUA=GUID=F78C0284521B4A4C8C05406B3E064651; ELQSTATUS=OK"
					},
					"processData": false,
					"mimeType": "multipart/form-data",
					"contentType": false,
					"data": form
				};

				$.ajax(settings)
					.done(function (response) {
						console.log(response);
						app.$body.removeClass('loading');
						overlayBgSelector.css('display', 'flex');
						_defExperienceTabUTagGenericSuccess();
					})
					.fail(function () {
						_defExperienceTabUTagGenericFailure();
					});

			}
			function _formSubmitForm5(selector) {


				const currentForm = $(selector);


				var form = new FormData();
				form.append("elqFormName", "DEFMinecraftEsports-Registration");
				form.append("elqSiteID", "1625795586");
				form.append("firstName", _capitalizeFirstLetter(currentForm.find('input[name=firstname]').val()));
				form.append("lastName", _capitalizeFirstLetter(currentForm.find('input[name=lastname]').val()));

				form.append("emailAddress", currentForm.find('input[name=email]').val());
				form.append("contactPhone", $('#phone6').val().length < 5 ? '' : $('#phone6').val());
				form.append("schoolName", _capitalizeFirstLetter(currentForm.find('input[name=schoolname]').val()));
				form.append("schoolLocation", currentForm.find('input[name=schoollocation]').val());
				form.append("yearGroup", currentForm.find('input[name=yeargroup]').val());
				form.append("teamName", _capitalizeFirstLetter(currentForm.find('input[name=schoolname]').val()));
				form.append("weeklyTimetable", currentForm.find('textarea[name=weeklytimetable\]').val());
				form.append("digitallearning", currentForm.find('input[name=digitalearning]:checked').val());
				form.append("ifYes", currentForm.find('input[name=timeintheweek]').val());
				form.append("multipleteams", currentForm.find('input[name=digitalearning1]:checked').val());

				var settings = {
					"url": "https://s1625795586.t.eloqua.com/e/f2",
					"method": "POST",
					"timeout": 0,
					"headers": {
						"Cookie": "ELOQUA=GUID=6637992B66DF4EF08830E6AE2EAC5603; ELQSTATUS=OK"
					},
					"processData": false,
					"mimeType": "multipart/form-data",
					"contentType": false,
					"data": form
				};




				$.ajax(settings).done(function (response) {
					console.log(response);
					app.$body.removeClass('loading');
					overlayBgSelector.css('display', 'flex');
					overlayBgSelector.addClass('overlay-bg--long')
					$('.overlay-bg__links').show()
					_defExperienceTabUTagGenericSuccess();
				})
					.fail(function () {
						_defExperienceTabUTagGenericFailure();
					});

			}

			_formValidationNSubmission(".eloqua-form-spotlight", _formSubmitFormHome);
			_formValidationNSubmission(".eloqua-form-home", _formSubmitFormHome);
			_formValidationNSubmission(".eloqua-form-1", _formSubmitForm1);
			_formValidationNSubmission(".eloqua-form-2", _formSubmitForm2);
			_formValidationNSubmission(".eloqua-form-3", _formSubmitForm3);
			_formValidationNSubmission(".eloqua-form-4", _formSubmitForm4);
			_formValidationNSubmission(".eloqua-form-5", _formSubmitForm5);

			$('.eloqua-form-home').on('submit', function () {

				console.log(' .eloqua-form-home  Sign Up Submit');
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "subscribe now",
					"event_lab": "sign up submit"
				});

			});

			$('.def-experiecne form').on('submit', function () {

				console.log(' Tabs all Sign Up On Submit');
				//debugger
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "join the def experience",
					"event_lab": "submit"
				});

			});





			$('.js-overlay-close-btn').on('click', function () {
				// $(this).parent().hide();

				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "tickets for def2022 go on sale soon",
					"event_lab": "close"
				});

				window.location.href = window.location.origin + window.location.pathname + $('.tabs-menu__link.active .btn-skewed').attr('href')
				location.reload();
			});

			$('.fieldset__check-box > input, .fieldset__check-radio > input').on('click', function () {
				$(this).parent().toggleClass('checked');
			});

			$('.fieldset__radio > input').on('click', function () {
				// //debugger
				if ($(this).parent().parent().hasClass('fieldset__radio-one-group')) {
					// console.log('yes');
					$('.fieldset__radio').removeClass('checked');
					$(this).parent().toggleClass('checked');
				} else {
					// console.log('no');
				}
				// $(this).parent().toggleClass('checked');
			});

			$('input[name="digitalearning"]').change(function () {

				if ($('input[name="digitalearning"]:checked').val() === 'Yes') {

					$('#week-time').removeClass('d-none')

				}
				else {
					$('#week-time').addClass('d-none')
				}
			})
		},
		header: function () {
			// Hide Header on on scroll down

			var didScroll;
			var lastScrollTop = 0;
			var delta = 5;
			var navbarHeight = $('.header').outerHeight();

			$(window).scroll(function (event) {

				didScroll = true;
			});

			setInterval(function () {
				if (didScroll) {
					hasScrolled();
					didScroll = false;
				}
			}, 250);

			function hasScrolled() {
				var st = $(window).scrollTop();


				// Make sure they scroll more than delta
				if (Math.abs(lastScrollTop - st) <= delta)
					return;

				// If they scrolled down and are past the navbar, add class .nav-up.
				// This is necessary so you never see what is "behind" the navbar.
				if (st > lastScrollTop && st > navbarHeight) {
					// Scroll Down
					$('.header').removeClass('nav-down').addClass('nav-up');
					$('.callout').removeClass('callout-down').addClass('callout-up');
					// $('.banner-social').removeClass('banner-social-down').addClass('banner-social-up');
				} else {
					// Scroll Up
					if (st + $(window).height() < $(document).height()) {
						$('.header').removeClass('nav-up').addClass('nav-down');
						$('.callout').removeClass('callout-up').addClass('callout-down');
						// $('.banner-social').removeClass('banner-social-up').addClass('banner-social-down');
					}
				}

				lastScrollTop = st;
			}
		},
		clickTags: function () {
			$('.logo,.logo-m').on('click', function () {
				// utag.link({
				// 	"event_name": "eventTracker",
				// 	"event_cat": "Top Navigation Menu",
				// 	"event_act": "Logo",
				// 	"event_lab": "Logo"
				// });

				utag.link({
					"event_name": "eventTracker",
					"event_cat": "navigation",
					"event_act": "logo",
					"event_lab": "logo"
				});
			})

			$('.nav-m__link.btn-skewed.btn-skewed--secondary-color').click(function () {

				utag.link({
					"event_name": "eventTracker",
					"event_cat": "navigation",
					"event_act": "header",
					"event_lab": $(this).text().toLowerCase()
				});
			})

			$('.fortnite-slider .btn-skewed').click(function () {


				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": $(this).parents('.fortnite-slider__scroll-content').find('.h2').text().toLowerCase(),
					"event_lab": $(this).text().toLowerCase()
				});

			})

			$('.banner__copy').on('click', function () {
				const pageTitle = $('.banner__title').text().toLowerCase();
				const btnName = $('.banner .btn-new').text().toLowerCase();
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "banner",
					"event_lab": `${btnName} : ${pageTitle}`
				});

			})

			$('.split-banner .btn-new').on('click', function () {
				const pageTitle = $('.title h2').text().toLowerCase();
				const btnName = $('.split-banner .btn-new').text().toLowerCase();
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "banner",
					"event_lab": `${btnName} : ${pageTitle}`
				});

			})

			$('.nav a , .nav-m a').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				// alert(navText)
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "navigation",
					"event_act": "header",
					"event_lab": navText
				});
			})
			$('.dual-btn a').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				// alert(navText)
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "navigation",
					"event_act": "header",
					"event_lab": navText
				});
			})

			$('.footer .footer__list  ul li a').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				//alert(navText);
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "navigation",
					"event_act": "footer",
					"event_lab": navText
				});
			})
			$('.signup-cta a').on('click', function () {
				const navText = $(this).text().toLowerCase();
				//alert(navText);
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "sticky bottom bar",
					"event_lab": navText
				});
			})




			$('.social-nav__ul a').on('click', function (e) {
				const navText = $(this).attr('data-title').toLowerCase();
				// alert(navText)
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "social",
					"event_act": "social icon",
					"event_lab": navText
				});
			})
			// $('.footer-nav__ul').on('click', function () {
			// 	const navText = $(this).text();
			// 	// console.log(navText);
			// 	utag.link({
			// 		"event_name": "eventTracker",
			// 		"event_cat": "navigation",
			// 		"event_act": "footer",
			// 		"event_lab": navText
			// 	});
			// })

			$('.callout  .callout__cta a').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				// alert(navText)
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "navigation",
					"event_act": "footer",
					"event_lab": navText
				});

			})
			$('#findOutMore').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "about dubai esports festival 2022",
					"event_lab": "find out more"
				});

			})
			$('#registerNow').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "be part of the leaguue",
					"event_lab": "register now"
				});
			})

			$('a.event').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "the latest update",
					"event_lab": navText
				});
			})

			$('a.stay-informed__link').on('click', function () {
				const navText = $(this).find('.stay-informed__item-title').text().toLowerCase();
				// alert(navText)


				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "our speakers",
					"event_lab": navText
				});



			})

			$('#discoverMore').on('click', function () {
				const navText = $(this).attr('title').toLowerCase();
				// alert($(this).text())
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "our speakers",
					"event_lab": navText
				});
			})

			$('#discoverMoreFan').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "for the fans",
					"event_lab": "discover more"
				});

			})

			$('.swiper-nav').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				// alert(navText)
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "for the fans",
					"event_lab": navText
				});
			})

			$('#becomeSponsor').on('click', function () {


				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "become a sponsor",
					"event_lab": "submit interest"
				});
			})

			$('.takeMeThere').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "there’s more to explore",
					"event_lab": "take me there"
				});

			})

			$('a.explore__media').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				// alert(navText)
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "there’s more to explore",
					"event_lab": navText
				});
			})

			// $('.swiper-pointer-events').on('click', function () {
			// 	utag.link({
			// 		"event_name": "eventTracker",
			// 		"event_cat": "modules",
			// 		"event_act": "There’s more to explore",
			// 		"event_lab": "image/video name"
			// 	});
			// })

			$('.explore-nav').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				// alert(navText)
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "there’s more to explore",
					"event_lab": navText
				});

			})

			$('.offers-on-us__link-wrap').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				// alert(navText)
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "offers on us",
					"event_lab": navText
				})

			})

			$('#discoverOffers').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "offers on us",
					"event_lab": "discover more"
				});
			})


			$('#buyTickets').on('click', function () {
				``
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "join the initiate summit",
					"event_lab": "buy tickets"
				});
			})
			$('.event.places').on('click', function () {
				const navText = $(this).attr('data-title').toLowerCase();
				// alert(navText);
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "join the initiate summit",
					"event_lab": navText
				});

			})

			$('.event.places.hotel').on('click', function () {
				const hotelName = $(this).attr('data-hotel').toLowerCase();
				// alert(hotelName);
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "places nearby the summit",
					"event_lab": "hotel click :" + hotelName
				});
			})

			$('.venue-map__list a').on('click', function () {
				const venueName = $(this).attr('data-venue').toLowerCase();
				// alert(venueName);
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "venue map",
					"event_lab": venueName
				});
			})
			$('.inner-nav a').on('click', function () {
				const venueName = $(this).attr('data-title').toLowerCase();
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "tab name",
					"event_lab": venueName
				});


			})
			$('.about-features__grid a').on('click', function () {
				const venueName = $(this).attr('data-title').toLowerCase();


				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "get involved",
					"event_lab": venueName
				});






			})

			$('#getDirection').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "dubai world trade centre",
					"event_lab": "get directions"
				});
			})

			$('.terms-of-use__close').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "terms of use",
					"event_lab": "close"
				});
			})

			$('#clickHereTerms').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "terms of use",
					"event_lab": "click here"
				});
			})
			$('#agreeTrems').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "terms of use",
					"event_lab": "i agree"
				});

			})
			$('#agreeTrems').on('click', function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "got questions",
					"event_lab": "accordion click : question"
				});

			})
			$('.home-tickets .btn-new').on('click', function () {

				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "get your tickets now",
					"event_lab": "view all"
				});

			})

			$('.home-tickets .btn-shadow').click(function () {
				const heading = $(this).parents('.tickets__grid-item').find('.tickets__grid-overlay-title').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "get your tickets now",
					"event_lab": `buy now : ${heading}`
				});
			})

			$('.home-tickets .tickets__grid-toggle-wrap').click(function () {
				const heading = $(this).parents('.tickets__grid-item').find('.tickets__grid-overlay-title').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "get your tickets now",
					"event_lab": `show more : ${heading}`
				});
			})


			$('.new-parallel-grid__grid-item .btn-new').click(function () {
				const heading = $(this).parents('.new-parallel-grid__grid-item').find('.new-parallel-grid__grid-title').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "what’s happening this def 2023",
					"event_lab": `buy now : ${heading}`
				});
			})

			$('.faqs__title-sec .btn-new').click(function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "got questions",
					"event_lab": 'show all'
				});
			})

			$('.faqs__item-list .faqs__list').click(function () {
				const heading = $(this).find('.faqs__inner-title').text().toLowerCase();
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "got questions",
					"event_lab": `faq: ${heading}`
				});
			});

			$('.social-frame-sec .btn-new').click(function () {

				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": "what’s on @dubaiesportsfestival",
					"event_lab": 'follow us'
				});
			});

			$('.contact-us-form .btn-new').click(function () {
				const heading = $(this).parents('.contact-us-form').find('.form_field_content h3').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": heading,
					"event_lab": 'sign up now'
				});
			});
			$('.about-festival__desc .btn-new').click(function () {
				const heading = $(this).parents('.about-festival .container').find('.about-festival__title').text().toLowerCase()
				const btnName = $(this).parents('.about-festival .container').find('.about-festival__desc .btn-new').text().toLowerCase()
				// const venueName = $(this).attr('data-title').toLowerCase();
				// const heading = $('.about-festival .about-festival__title').text();
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": heading,
					"event_lab": btnName
				});
			});

			// $('.about-festival .about-festival__desc .btn-new').click(function () {
			// 	// const venueName = $(this).attr('data-title').toLowerCase();
			// 	const heading = $(this).parents('.about-festival .container .row').find('.about-festival__title').text().toLowerCase()
			// 	const venueName = $(this).parents('.about-festival .about-festival__desc').find('.btn-new').text().toLowerCase()
			// 	utag.link({
			// 		"event_name": "eventTracker",
			// 		"event_cat": "modules",
			// 		"event_act": heading,
			// 		"event_lab": venueName
			// 	});
			// })


			$('.game-expo-section7 .btn-new').click(function () {
				const btnName = $('.game-expo-section7 .btn-new').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": 'venue map',
					"event_lab": btnName
				});
			});
			$('.article-listing .btn-new').click(function () {
				const heading = $(this).parents('.stay-informed__item').find('.stay-informed__item-title').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": 'in the know',
					"event_lab": `read more : ${heading}`
				});
			});



			$('.parallel-grid .row a').click(function () {
				const heading = $(this).parents('.parallel-grid .row').find('.parallel-grid__sub-title').text().toLowerCase()
				const btnName = $(this).parents('.parallel-grid .row').find('a').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": heading,
					"event_lab": btnName
				});
			});
			$('.thank-you .btn-new').click(function () {
				const heading = $('.thank-you h1').text().toLowerCase()
				const btnName = $('.thank-you .btn-new').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": heading,
					"event_lab": btnName
				});
			});
			$('.regional-sec .btn-new').click(function () {
				const heading = $(this).parents('.regional-sec').find('.regional-sec__title').text().toLowerCase()
				const btnName = $(this).parents('.regional-sec').find('.btn-new').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": heading,
					"event_lab": btnName
				});
			});

			$('.tickets .btn-shadow').click(function () {
				const heading = $(this).parents('.tickets__grid-item').find('.tickets__grid-overlay-title').text().toLowerCase()
				const btnName = $(this).parents('.tickets__grid-item').find('.btn-shadow span').text().toLowerCase()
				const title = $(this).parents('.section').find('.fz-64').text().toLowerCase()
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": `${title}`,
					"event_lab": `${btnName} : ${heading}`
				});

			});

			$('.about-festival.circle-bg-center .btn-new').click(function () {
				utag.link({
					"event_name": "eventTracker",
					"event_cat": "modules",
					"event_act": 'about dubai esports and games festival 2023',
					"event_lab": 'learn more'
				});
			})





		},

		calendar: function (data) {



			var events =

				[
					{
						"title": "Taysir Batniji: No Condition is Permanent ",
						"start": "2022-09-15T00:00:00",
						"end": "2023-01-21T00:00:00",
						"link": "/en/experiences/exhibitions/taysir-batniji/"
					},
					{
						"title": "Sophia Al-Maria Daydream Therapy",
						"start": "2022-09-15T00:00:00",
						"end": "2023-01-21T00:00:00",
						"link": "/en/experiences/exhibitions/sophia-al-maria-daydream-therapy/"
					},
					{
						"title": "Majaz Contemporary Art Qatar",
						"start": "2022-09-16T00:00:00",
						"end": "2023-02-25T00:00:00",
						"link": "/en/experiences/exhibitions/majaz-contemporary-art/"
					},
					{
						"title": "Pipilotti Rist’s Your Brain to Me, My Brain to You",
						"start": "2022-03-21T00:00:00",
						"end": "2023-01-14T00:00:00",
						"link": "/en/experiences/exhibitions/pipilotti-rist-s-your-brain/"
					},
					{
						"title": "Abeer Al-Tamimi: Beyond the Rules",
						"start": "2022-07-28T00:00:00",
						"end": "2022-09-24T00:00:00",
						"link": "/en/experiences/exhibitions/abeer-al-tamimi-beyond-the-rules/"
					},
					{
						"title": "Abstraction: Subverting Reality",
						"start": "2022-07-28T00:00:00",
						"end": "2022-09-24T00:00:00",
						"link": "/en/experiences/exhibitions/abstraction-subverting-reality/"
					},
					{
						"title": "A Sneak Peek at Qatar Auto Museum ",
						"start": "2022-08-19T00:00:00",
						"end": "2023-01-20T00:00:00",
						"link": "/en/experiences/exhibitions/qatar-auto-museum-project/"
					},
					{
						"title": "World of Football",
						"start": "2022-10-02T00:00:00",
						"end": "2023-04-01T00:00:00",
						"link": "/en/experiences/exhibitions/world-of-football/"
					},
					{
						"title": "Labour of Love: Embroidering Palestinian History",
						"start": "2022-10-12T00:00:00",
						"end": "2023-01-28T00:00:00",
						"link": "/en/experiences/exhibitions/labour-of-love-embroidering-palestinian-history/"
					}
				]

			// data?.FeaturedEvents?.map((item) => {
			//   var obj = {}

			//   obj.title = item.Title
			//   obj.start = item.StartDate;
			//   obj.end = item.EndDate;
			//   obj.link = item.Url;
			//   events.push(obj)


			// })




			// const getTabID = $(".tab").attr("data-id");
			// const getTrigger = $(".events-calendar__item-view");
			// getTrigger.on("click", function () {
			//   getTrigger.removeClass("active");
			//   $(this).addClass("active");
			//   if (this.attr("id") == getTabID) {
			//   }
			// });



			var calendarEl = document.getElementById('calendar');

			var calendar = new FullCalendar.Calendar(calendarEl, {
				initialDate: '2022-11-09',

				initialView: 'timeGridDay',
				slotMinTime: "08:00:00",
				slotMaxTime: "16:00:00",
				headerToolbar: {
					right: 'title,prev,next',
					left: ''

					//right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
				},
				height: 'auto',
				navLinks: true, // can click day/week names to navigate views
				dayHeaders: false,
				allDaySlot: false,

				//eventMinHeight: 100,

				eventTimeFormat: {
					hour: '2-digit',
					minute: '2-digit',
				},

				// editable: true,
				// selectable: true,
				// selectMirror: true,
				// nowIndicator: true,
				events: [
					{
						title: 'Registration & Welcome Refreshments',
						start: '2022-11-09T08:00:00',
						end: '2022-11-09T08:30:00',
						hours: '30 Minutes',
						classNames: '',
					},
					{
						title: 'Inauguration Speech:Expanding and Investing in the Local Gaming and eSports Industry',
						start: '2022-11-09T08:40:00',
						end: '2022-11-09T08:50:00',
						hours: '10 Minutes',
						classNames: 'theme1',

					},
					{
						title: 'Inauguration Speech:The Vision and Creation Story of DEF',
						start: '2022-11-09T08:50:00',
						end: '2022-11-09T09:00:00',
						hours: '10 Minutes',
						classNames: 'theme1',
					},
					{
						title: 'Panel Discussion:Positioning Dubai as a Global Gaming Hub and eSports Destination',
						start: '2022-11-09T09:00:00',
						end: '2022-11-09T09:40:00',
						hours: '40 Minutes',
						classNames: 'theme2',
						desc: `
						•	The incentives for setting up your regional headquarters in Dubai<br/>
						•	Success stories from gaming and eSports organisations already established in the Emirate<br/>
						•	An innovation-driven economy – highly skilled talent, infrastructure and community support<br/>
						Moderator:<br/>
						Paul Dawalibi, CEO, Holodeck Ventures<br/>
						Panellists:<br/>
						Chenfan Wang, GM of Global Business, VSPN
						Senior Representative, DET
						Kishan Deepak Palija, CEO, Geekay Group
						John Lacey, MENA Head, Level Infinite
						Christoph Timm, Co-Founder, Nigma Galaxy

						`
					},
					{
						title: 'Panel Discussion:Helping the Ecosystem Grow - Investment in Gaming and eSports',
						start: '2022-11-09T09:40:00',
						end: '2022-11-09T10:20:00',
						hours: '40 Minutes',
						classNames: 'theme2',
						desc: `•	CV vs PE – how different investor types engage with the industry<br/>
						•	Demonstrating business concepts and operational viability to attract funds<br/>
						Moderator:<br/>
						Paul Dawalibi, CEO, Holodeck Ventures<br/>
						Panellists:
						Dani Contreras Pérez, Head of Gaming, Belobaba Fund
						Frank A. Sliwka, COO, Epulze
						Lucy Chow, General Partner, WBAF Angels Investment Fund
						Roberto Croci, Entrepreneurs Committee Member, Capital Club Dubai
						`
					},
					{
						title: 'Networking & Refreshments Break',
						start: '2022-11-09T10:20:00',
						end: '2022-11-09T10:40:00',
						hours: '20 Minutes',
						classNames: '',
					},
					{
						title: 'Alternative Routes – from Gaming Creator Management to World Champions ',
						start: '2022-11-09T10:40:00',
						end: '2022-11-09T11:00:00',
						hours: '20 Minutes',
						classNames: 'theme3',
						desc: `•	A journey on how different strategies can lead to success in esports<br/>
						•	Leveraging industry practices, and expert insights to create a diversified portfolio<br/>
						•	Utilising resources and assets in formats that create a positive force of growth internally<br/>
						Tryke Gutierrez, CEO, Tier One Entertainment
						
						`
					},
					{
						title: 'Panel Discussion:						Spearheading Talent Incubation, Acquisition and Management in the GCC 						',
						start: '2022-11-09T11:00:00',
						end: '2022-11-09T11:40:00',
						hours: '40 Minutes',
						classNames: 'theme2',
						desc: `•	Incubation – offering motivated talent individual support with participation in tournaments, coaching, professional support and team try-outs to introduce them to the competitive scene<br/>
						•	Acquisition – gamer and content creator recruitment in 2022, what you need to know<br/>
						•	Management – backing influencers to deal with brand negotiations and collaboration<br/>
						Moderator:<br/>
						Sebastian Läger, Founder, TwogNation<br/>
						Panellists:<br/>
						Lalit Vase, Founder & CEO, NASR ESPORTS
						Meena George, Head of Esports, Geekay Group
						Mohamed Ghareeb, Head of Esports	Team, RA'AD
						Wadih Sayah, Head of Esports, YaLLa Esports
						Youssef Mohsen, Founder & Managing Partner, Anubis Gaming
						
						`
					},
					{
						title: 'Panel Discussion:						Creating Wholistic eSports Agencies that Become Major Drivers of Community Growth												',
						start: '2022-11-09T11:40:00',
						end: '2022-11-09T12:20:00',
						hours: '40 Minutes',
						classNames: 'theme2',
						desc: `•	Understanding your audience and what content brings value to it<br/>
						•	Beyond engagement data analytics and high-quality content production equipment<br/>
						•	Publisher management and strategy development for campaigns that help the marketplace expand<br/>
						Moderator:<br/>
						Abdallah Al Ghafari, PUBG Mobile Esports Manager, Level Infinite<br/>
						Panellists:<br/>
						Andreas Hadjipaschali, CEO & Co-Founder, Bravado Gaming
						Aravind Swaminathan, Co-Founder & Business Development Director, Calyx
						Elie Honain, CEO, Quest
						Klaus Kajetski, CEO, YaLLa Esports
						Matthew Pickering, CEO, PLG - Power League Gaming
						
						`
					},
					{
						title: 'Presentation:						Ensuring a Low-Latency Playing Experience – Overcoming Performance Inhibitors for Pro and Home Gamers Alike										',
						start: '2022-11-09T13:00:00',
						end: '2022-11-09T13:20:00',
						hours: '20 Minutes',
						classNames: 'theme2',
						desc: `•	How low latency and better bandwidth can improve the quality of cloud gaming<br/>
						•	Getting closer to the users through infrastructure and interconnections<br/>
						•	Furthering the mobile gaming boost with 5G penetration<br/>
						Speaker:<br/>
						Reserved for TelCo Sponsor
						
						
						`
					},
					{
						title: 'Networking & Refreshments Break',
						start: '2022-11-09T12:40:00',
						end: '2022-11-09T13:00:00',
						hours: '20 Minutes',
						classNames: '',
					},
					{
						title: 'Panel: 						Designing Broadcasts – How Audiences Want to Access and Consume Content													',
						start: '2022-11-09T13:20:00',
						end: '2022-11-09T14:00:00',
						hours: '40 Minutes',
						classNames: 'theme2',
						desc: `•	Graphics, content and animation to meet your audience’s expectations<br/>
						•	Supporting streamers with advanced data analytics and media tools<br/>
						Moderator:<br/>
						Mufaddal Fakhruddin, Senior Editor, IGN<br/>
						Panellists:<br/>
						Arif Aabed, Mobile Apps & Gaming Business Portfolio Manager, MBC Group
						Elie Gemayel, CSO, Quest
						Karim El-Henawe, Founder and CEO, Heros.live
						Mohammed Albsimi, CEO, TrueGaming
						Ralph Bejjani, Head of Production, Calyx
						
						
						
						`
					},
					{
						title: 'Fireside chat: 						Delivering State of the Art Tournaments and Leagues																',
						start: '2022-11-09T14:00:00',
						end: '2022-11-09T14:40:00',
						hours: '40 Minutes',
						classNames: 'theme2',
						desc: `•	Online vs offline organisation success factors<br/>
						•	Creating a viewership experience for the fan<br/>
						Moderator:<br/>
						Sebastian Läger, Founder, TwogNation<br/>
						Panellists:<br/>
						Abhijit Pattanaik, Co-Founder & CGO, Playtonia eSports
						Elie Honain, CEO, Quest
						Hashem Alborno, Co-founder & COO, Gamers Lounge
						
						
						
						
						`
					},
					{
						title: 'Reinventing the Fan Experience and eSports Tourism – International Best Practise',
						start: '2022-11-09T14:40:00',
						end: '2022-11-09T14:50:00',
						hours: '10 Minutes',
						classNames: 'theme2',
						desc: `•	Mega esports event and understanding data on domestic and international visitor max radius<br/>
						•	Creating interactive events with different elements that enable fan participation<br/>
						•	The impact on the cities that host these events reflected through direct spending<br/>
						Speaker:<br/>
						Chenfan Wang, GM of Global Business, VSPN
						
						
						
						
						
						`
					},

					{
						title: 'Networking Lunch and End of Day One',
						start: '2022-11-09T15:00:00',
						end: '2022-11-09T16:00:00',
						hours: '1 Hour',
						classNames: '',
					},
				],

				eventDidMount: function (event, element) {
					if (event.event._def.extendedProps.hours)
						$(event.el).find('.fc-event-time').append(`<span class='fc-event-time--hour'>${event.event._def.extendedProps.hours}</span>`)
					if (event.event._def.extendedProps.desc)
						$(event.el).find('.fc-event-title').append(`<div class='fc-event-desc'>${event.event._def.extendedProps.desc}</div>`)

				}

			});

			calendar.render();




		},

		accordion: function () {

			$('.faqs__item').click(function () {
				if ($(this).hasClass('faqs__open')) {
					$(this).removeClass('faqs__open');
				} else {
					$('.faqs__item').removeClass('faqs__open');
					$(this).addClass('faqs__open');
				}
			});
		},


		formControll: function () {

			$(document).ready(function () {
				// Hide all headings initially
				$('.form_field_content').hide();

				// Show default heading
				$('.captioForm-1').show();

				// Show/hide heading based on selected option
				$('#selectSelector').change(function () {
					var selectedOption = $(this).prop('selectedIndex') + 1;
					console.log("Selected option: " + selectedOption);

					// Hide all headings
					$('.form_field_content').hide();

					// Show the corresponding heading based on the selected option
					$('.captioForm-' + selectedOption).show();
				});
			});

			var isFormValid = false

			$(".myForm").validate({

				// Make sure the form is submitted to the destination defined
				// in the "action" attribute of the form when valid
				rules: {
					interestedIn: {
						required: true
					},

					firstName: {
						alpha: true,
						maxlength: 40
					},
					lastName: {
						alpha: true,
						maxlength: 40
					},

					emailAddress: {
						customEmail: true,
						maxlength: 64
					},
					sponsor_companyName: {
						maxlength: 40
					},

					registratingSchool_schoolName: {
						maxlength: 40
					},
					registratingSchool_designation: {
						maxlength: 40
					},

					sponsor_designation: {
						maxlength: 40
					},
					gameexpo_designation: {
						maxlength: 40
					},
					gameexpo_companyName: {
						maxlength: 40
					},

					gender: {
						required: false
					},
					country: {
						required: true
					},
					registratingSchool_registerFor: {
						required: true
					},
					sponsorship_opportunity: {
						required: true
					},

					sponsorship_opportunity: {
						required: true
					},
					changeHandle: {
						required: true
					},

					// Message: {
					// 	required: true,
					// 	minlength: 2,
					// 	maxlength: 512,
					// 	lettersonly: false
					// }

				},
				highlight: function (element) {
					$(element).parent().addClass("field-error");

					$(element).parents('fieldset').find('legend').addClass("field-error");
				},
				unhighlight: function (element) {
					$(element).parent().removeClass("field-error");
					$(element).parents('fieldset').find('legend').removeClass("field-error");
				},
				submitHandler: function (form) {
					//	form.submit();
					//	alert('form is valid')
					isFormValid = true;

				}
			});
			$('.myForm').on('submit', function (e) {
				e.preventDefault();
				//generateCaptchaToken()

				if (!isFormValid) {
					return false
				}
				else {



					$(this).get(0).submit()
				}


			})



		},
		miscFunction: function () {
			$('.tickets__grid-wrap-toggle-title').on('click', function () {
				$(this).next('.tickets__grid-list--small-list').slideToggle('slow');
				$(this).toggleClass('opened');
			})
		},
		contryCode: function () {
			var selectCode = $('.iti__selected-dial-code').text();
			$('#countryCode').val(selectCode);


			$(".iti__selected-dial-code").on("DOMSubtreeModified", function () {

				var selectCode = $('.iti__selected-dial-code').text();
				$('#countryCode').val(selectCode);
			});



		},
		popUpImg: function () {
			$(document).ready(function () {
				// Open the popup when clicking on the thumbnail
				$('.popup-image').click(function () {
					var imageSrc = $(this).attr('src');
					$('.popup-content').attr('src', imageSrc);
					$('.popup').fadeIn();
				});

				// Close the popup when clicking on the close button
				$('.close-btn').click(function () {
					$('.popup').fadeOut();
				});
			});


		}
		,

		copyText() {
			$(document).ready(function () {
				$("#copyText").click(function () {
					const textToCopy = $(this).text();

					navigator.clipboard.writeText(textToCopy)
						.then(function () {
							$("#copyStatus").fadeIn().delay(1500).fadeOut();
							console.log("Text copied to clipboard!");
						})
						.catch(function (error) {
							console.error("Failed to copy text: ", error);
						});
				});
			});
		},

		init() {

			app.detectCulture();
			app.lazyLoad()
			app.detectDevice();
			app.resizeListner();
			app.addEventListner();
			// app.mobileSwiper()
			app.swiper()
			app.mobileNav();
			app.tabs();
			app.spotlightForm();
			app.privacyDrawer();
			app.header();
			app.formValidation();
			app.clickTags();
			app.accordion();
			app.formControll();
			//	app.calendar();
			app.miscFunction();
			app.contryCode();
			app.popUpImg();
			app.copyText();

			//dummy active 

			$('.inner-nav a').filter(function () {
				return this.href === location.href;
			}).addClass('active');

			$('.nav__ul a').filter(function () {
				return this.href === location.href;
			}).addClass('active');

		},
	}
	window.app = app;

}(jQuery));

$(document).ready(() => {
	window.app.init();
});


$.validator.addMethod("alpha", function (value, element) {
	return (
		this.optional(element) ||
		/^(?:[a-zA-Z@,=%$#&_\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFF]|(?:\uD802[\uDE60-\uDE9F]|\uD83B[\uDE00-\uDEFF])){0,30}$/i.test(
			value
		)
	);
}, "Name is not valid");

var emailError = $('body').hasClass('ar') ? "الرجاء إدخال عنوان بريد إلكتروني صالح! " : 'Please enter valid email address!'


jQuery.validator.addMethod("customEmail", function (value, element) {
	return this.optional(element) || /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i.test(value);
}, emailError);
